// import apiFetch from '../apiFetch'
export default function (token) {
  return {} // apiFetch({endPoint: 'notification', method: 'GET', body: null, token: token})
}
